import React, { useMemo } from "react";
import { Button, Loading, Checkbox, Input } from '@nextui-org/react';

const Filter = ({
  documentTypeList = [],
  documentNumber,
  employeeId,
  documentType,
  dateEntered,
  openCheck,
  closeCheck,
  setValueToState,
  resetFilter,
  fetchSafetyDocumentList,
  fetching
}) => {
  // Memoize options for performance
  const options = useMemo(
    () => documentTypeList.map(item => ({
      value: item.type_name,
      label: item.type_name
    })),
    [documentTypeList]
  );

  return (
    <div className="pa2" style={{ width: 200 }}>
      <div>
        <label className="f5">Document Number</label>
        <Input
          css={{ $$inputBorderRadius: "0", w: '100%', h: 30, mt: 5 }}
          shadow={false}
          bordered
          rounded={false}
          type='number'
          min={0}
          onChange={e => setValueToState("documentNumber", e.target.value)}
          value={documentNumber}
        />
      </div>
      <div className="mt3">
        <label className="f5">Employee Id</label>
        <Input
          type="text"
          placeholder="Enter employee id"
          onChange={e => setValueToState("employeeId", e.target.value)}
          css={{ $$inputBorderRadius: "0", w: '100%', h: 30, mt: 5 }}
          shadow={false}
          bordered
          rounded={false}
          value={employeeId}
        />
      </div>
      <div className="mt3">
        <label className="f5">Document Type</label>
        <div className="w-100">
          <select
            className="select select-sm select-bordered w-full h-6 mt-1 rounded-none"
            value={documentType || ""}
            onChange={e => setValueToState("documentType", e.target.value)}
          >
            <option value="">Select Doc Type</option>
            {options.map(opt => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
      </div>
      <div className="mt3">
        <label className="f5">Date Entered</label>
        <Input
          css={{ $$inputBorderRadius: "0", w: '100%', h: 30, mt: 5 }}
          shadow={false}
          bordered
          rounded={false}
          type="date"
          onChange={e => setValueToState("dateEntered", e.target.value)}
          value={dateEntered}
        />
      </div>

      <div className="flex flex-row mt3">
        <div className="f5 w4 w-80">Open</div>
        <div className="w-20">
          <Checkbox
            checked={openCheck === 1}
            onChange={() => {
              setValueToState("openCheck", openCheck === 1 ? 0 : 1);
              setValueToState("closeCheck", 0);
            }}
          />
        </div>
      </div>

      <div className="flex flex-row mt2">
        <div className="f5 w4 w-80">Close</div>
        <div className="w-20">
          <Checkbox
            checked={closeCheck === 1}
            onChange={() => {
              setValueToState("closeCheck", closeCheck === 1 ? 0 : 1);
              setValueToState("openCheck", 0);
            }}
          />
        </div>
      </div>

      <div className="flex flex-row justify-center items-center justify-between mt3">
        <Button
          ghost
          auto
          css={{ br: 0, color: '$gray600', borderColor: '$gray600' }}
          onClick={resetFilter}
        >
          Reset
        </Button>

        {fetching ? (
          <Button auto css={{ br: 0 }} loading>
            <Loading type='points' size="md" color='white' />
          </Button>
        ) : (
          <Button
            auto
            css={{ br: 0 }}
            onClick={fetchSafetyDocumentList}
          >
            Search
          </Button>
        )}
      </div>
    </div>
  );
};

export default Filter;